import DropDownFilterCell from "../../../components/GridCell/GridDropDownFilterCell";
import { API_GATEWAY, PR_DEP } from "../../../config/globalVariables";
import GridDateFormatCell from "../../../components/GridCell/GridDateFormatCell";
import { t } from "i18next";

export const eventGridColumns = [
  {
    field: "etkinliK_ADI",
    title_key: "event_name",
    width: "256px",
    filterable: true,
  },
  {
    field: "boluM_KODU",
    title_key: "section_name",
    width: "200px",
    cell: (props) => {
      const value = props.dataItem.boluM_ADI;
      return <td>{value}</td>;
    },
    filterable: false,
  },
  {
    field: "etkinliK_TIPI_KODU",
    title_key: "event_type",
    width: "200px",
    cell: (props) => {
      const value = props.dataItem.etkinliK_TIPI_ADI;
      return <td>{value}</td>;
    },
    filterCell: (props) => (
      <DropDownFilterCell
        url={API_GATEWAY + PR_DEP + "/etkinliktipi/get-list"}
        textField="etkinliK_TIPI_ADI"
        dataItemKey="etkinliK_TIPI_KODU"
        {...props}
      />
    ),
    filterable: true,
  },
  {
    field: "baS_TAR",
    title_key: "start_date",
    width: "200px",
    cell: (props) => GridDateFormatCell(props, t("date_formats.shortDateTime")),
    filterable: false,
  },
  {
    field: "biT_TAR",
    title_key: "end_date",
    width: "200px",
    cell: (props) => GridDateFormatCell(props, t("date_formats.shortDateTime")),
    filterable: false,
  },
  {
    field: "kuruM_TAKVIMINDE_GORUNSUN",
    title_key: "company_calendar",
    width: "200px",
    filterCell: (props) => (
      <DropDownFilterCell
        data={[
          { value: "EVET", text: t("yes") },
          { value: "HAYIR", text: t("no") },
        ]}
        {...props}
      />
    ),
    cell: (props) => {
      const value = props.dataItem.kuruM_TAKVIMINDE_GORUNSUN;
      return <td>{t(value)}</td>;
    },
    filterable: true,
  },
  {
    field: "olusturaN_AD_SOYAD",
    title_key: "created_by",
    width: "200px",
    filterable: true,
  },
  {
    field: "yurticI_YURTDISI",
    title_key: "region",
    width: "200px",
    filterCell: (props) => (
      <DropDownFilterCell
        data={[
          { value: "YURTICI", text: t("domestic") },
          { value: "YURTDISI", text: t("international") },
        ]}
        {...props}
      />
    ),
    filterable: true,
    cell: (props) => {
      const value = props.dataItem.yurticI_YURTDISI;
      return <td>{t(value)}</td>;
    },
  },
  {
    field: "misafiR_SAYISI",
    title_key: "count_of_guests",
    width: "200px",
    filter: "numeric",
    filterable: true,
  },
  {
    field: "aciklama",
    title_key: "description",
    width: "200px",
    filterable: false,
  },
];
